import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { StoreService } from '../../core';
import { AdminCatalogsService } from './admin.catalogs.service';
import { CatalogsModel, Catalog } from '../../shared';

@Component({
  selector: 'webstore-catalogs',
  templateUrl: './admin.catalogs.component.html',
  styleUrls: ['./admin.catalogs.component.css']
})

export class AdminCatalogsComponent implements OnInit {

  private mainModel: CatalogsModel;
  catalogsList: Catalog[] = [];
  file: File;

  constructor(
    protected store: StoreService,
    protected catalogs: AdminCatalogsService,
    protected router: Router
  ) { }

  ngOnInit(): void {
    this.getCatalog();
  }

  //////convertImages(): void {
  //////  this.store.showSplash(true);
  //////  this.mainModel.Mode = 'CONVERT';
  //////  this.catalogs.convertFiles(this.mainModel).subscribe((result: CatalogsModel): void => {
  //////    this.store.showSplash(false);
  //////    if (!result.HasError)
  //////      this.mainModel = result;
  //////  });
  //////}

  getUrl(imgUrl: string): string {
    return this.store.getImgUrl(imgUrl);
  }

  fileChange(event: any): void {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.file = fileList[0];
    }
  }

  uploadFiles(pIdent: string, pMode: string): void {
    this.store.showSplash(true);
    if (this.file) {
      const imgsize: number = this.file.size;
      let filetype: string = '';
      switch (this.file.name.toLowerCase().split('.').pop()) {

        default: filetype = 'Not supported'; break;
        case 'jpg': filetype = 'image/jpg'; break;
        case 'svg': filetype = 'image/svg'; break;
        case 'jpeg': filetype = 'image/jpeg'; break;
        case 'png': filetype = 'image/png'; break;
        case 'gif': filetype = 'image/gif'; break;
        case 'bmp': filetype = 'image/bmp'; break;
        case 'dwg': filetype = 'image/vnd.dwg'; break;
      }
      if (filetype !== 'Not supported') {
        if (imgsize <= 250000 && imgsize > 0) {
          this.catalogs.uploadFiles(pMode, this.file, pIdent).subscribe((Data: ArrayBuffer): void => {
              //this.store.showAlert(this.store.getMsg('msgAdminCat5'), this.store.getMsg('msgAdminCat6'));
            this.store.showAlert(this.store.getTrad('msgAdminCat6'));
              this.store.showSplash(false);
              this.getCatalog();
            }, (error: any): void => {
              this.store.showSplash(false);
              this.store.showAlert(JSON.stringify(error));
              this.store.showAlert('error saving picture (size or type)');
            });
        }
        else {
          this.store.showSplash(false);
          this.store.showAlert(this.store.getTrad('msgAdminCat2'));
        }

      }
      else {
        this.store.showSplash(false);
        this.store.showAlert(this.store.getTrad('msgAdminCat3'));
      }
    }
    else {
      this.store.showSplash(false);
      this.store.showAlert(this.store.getTrad('msgAdminCat4'));
    }
  }

  private getCatalog(): void {
    this.store.showSplash(true);
    this.catalogs.getCatalogs().subscribe((data: CatalogsModel): void => {
      this.store.showSplash(false);
      if (!data.HasError) {
        this.mainModel = data;
        if (data.CatalogueList.length === 0) {
          this.store.showAlert(this.store.getTrad('msgAdminCat1'));
          return;
        }

        this.catalogsList = data.CatalogueList;
      }
    }, (error: any): void => { console.error(JSON.stringify(error)); });
  }
}
